import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import * as fromCommon from '../../shared';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { ExpenseItemPresenterComponent } from '../presenter/expense-item-presenter.component';
import * as fromActions from '../store/expense-item.actions';
import { ExpenseItem } from '../store/expense-item.model';
import * as fromReducer from '../store/expense-item.reducer';
@Component({
    selector: 'ef-expense-item-feature',
    templateUrl: './expense-item-feature.component.html',
    styleUrls: ['./expense-item-feature.component.scss'],
    standalone: false
})
export class ExpenseItemFeatureComponent implements OnInit, OnDestroy {
    process$: Observable<fromShared.Process>;

    @ViewChild(ExpenseItemPresenterComponent, { static: true })
    presenter: ExpenseItemPresenterComponent;

    public expenseitems$: Observable<ExpenseItem[]>;

    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromCommon.IStatusMessage>;

    active = true;
    ShowError = new ReplaySubject<fromShared.Errors.IShowErrors>(1);

    constructor(
        private log: LoggingService,
        private store: Store<fromReducer.State>
    ) {}

    ngOnInit(): void {
        this.store.dispatch(fromActions.getExpenseItems());
        this.setupObservables();
    }

    ngOnDestroy(): void {
        this.active = false;
        this.store.dispatch(fromActions.clearExpenseItems());
    }

    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        this.expenseitems$ = this.store.pipe(
            select(fromReducer.selectAll),
            map(x => clone(x))
        );
        combineLatest([this.process$, this.ShowError])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });
    }

    onLoadExpenseItems($event) {
        this.log.verbose({
            type: 'ExpenseItemFeatureComponent:onLoadExpenseItems'
        });
    }

    onSaveExpenseItems($event) {
        this.log.verbose({
            type: 'ExpenseItemFeatureComponent:onSaveExpenseItems'
        });
        this.store.dispatch(
            fromActions.putExpenseItems({ expenseItems: $event })
        );
    }
}
